import { EchartsWithTheme, useTheme } from '@maxtropy/components';
import { accuracyOption } from '../../chartOptions';
import AnalysisToolbar from '../AnalysisToolbar';
import SectionHeader from '../SectionHeader';
import styles from './index.module.scss';

const AccuracyAnalysis = () => {
  const theme = useTheme();

  return (
    <section className={styles.section}>
      <SectionHeader title="光伏预测精度分析" />
      <AnalysisToolbar enforceRangeRules />
      <EchartsWithTheme theme={theme} option={accuracyOption} style={{ height: 280, marginTop: 16 }} />
    </section>
  );
};

export default AccuracyAnalysis;
